import React, { Component } from 'react';
import { Router, Route } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory'

import { WebGLMoon } from "./webgl/index";

import { ProfileView } from "./components/ProfileView";

import './App.css';

const history = createBrowserHistory()

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingMoon: true
    };
  }

  componentDidMount() {
    if (window.navigator.userAgent) {
      this.webGLMoon = new WebGLMoon(this.onCompleteLoading);
    } else {
      this.setState({ loadingMoon: false });
    }
  }

  onCompleteLoading = () => {
    this.setState({ loadingMoon: false });
  }

  render() {
    const { loadingMoon } = this.state;

    return (
      <Router history={history}>
        <div className="lunar__container">
            <Route path="/:id" render={({ match }) => (
              <ProfileView
                moon={!loadingMoon && this.webGLMoon}
                id={match.params.id}
              />
            )} />
          <div id="webgl-container"></div>
        </div>
      </Router>
    );
  }
}

export default App;